import React, { useState } from "react";
import RoiCalculatorWidget from "./RoiCalculatorWidget";
import Industries_carousel_pa from "./Industries_carousel_pa";
import Industries_carousel_global from "./industries_carousel_global";
import Support from "../Home/Support";
import Contact_form from "../Home/Contact_form";
import Modal_started from "../Home/Modal_started";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import useLocalePrefix from "../utils/useLocalePrefix";
import Modal_new from "../Home/Modal_new";
import { Helmet } from "react-helmet";

const Home_new_sv = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const features = [
    {
      tag: "Inventario al día",
      title: "Gestión de inventario automática",
      description:
        "Que reduzca pérdidas, avise cuando falten ingredientes y permita compras inteligentes.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/GESTION-DE-INVENTARIO-AUTOMATICA_kow1hl.png",
    },
    {
      tag: "Facturación electrónica",
      title: "Facturación digital eficiente",
      description:
        "Genera facturas electrónicas al instante, lleva un control de tus ventas y cumple con todos los requisitos fiscales sin complicaciones.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/FACTURACION-DIGITAL-EFICIENTE_bzc8pt.png",
    },
    {
      tag: "Control de mesas",
      title: "Gestión del personal",
      description:
        "Control de turnos, comisiones, rendimiento y roles dentro del sistema.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/GESTION-DE-PERSONAL_jzcmhm.png",
    },
    {
      tag: "InvuReport",
      title: "Reportes avanzados de ventas",
      description:
        "Gráficos y análisis por plato, turno, mes o empleado para tomar decisiones rápidas.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/REPORTES-AVANZADOS-DE-VENTAS_wzaucp.png",
    },
    {
      tag: "Control de mesas",
      title: "Control de mesas y reservas",
      description:
        "Visualización clara de ocupación, tiempos de permanencia y disponibilidad en tiempo real.",
      image:
        "https://img.invupos.com/webinvu/homenew/Whatsapp%20Catalogo-12%203.png",
    },
    {
      tag: "Control de mesas",
      title: "Manejo de promociones",
      description:
        "Crear ofertas, combos y descuentos fácilmente sin afectar inventario ni contabilidad.",
      image:
        "https://img.invupos.com/webinvu/homenew/invu%20mockups%20multiple%20screens%203.png",
    },
    {
      tag: "Control de mesas",
      title: "Para franquicias o sucursales",
      description:
        "Administración centralizada si tienen más de un local, con reportes consolidados.",
      image:
        "https://img.invupos.com/webinvu/homenew/1%202.png",
    },
  ];

  const features1 = [
    { text: "Reduce las filas y tiempos de espera" },
    { text: "Aumenta el ticket promedio" },
    { text: "Disminuye errores en pedidos" },
    { text: "Optimiza el personal" },
    { text: "Facilita la actualización del menú" },
    { text: "Impulsa la fidelización" },
    { text: "Mayor satisfacción" },
    { text: "Sistema todo integrado" },
    { text: "Reportes en tiempo real" },
    { text: "Delivery en segundos" },
  ];

  const features2 = ["POS", "Inventarios", "KDS", "Reportes", "Facturación"];
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % features.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + features.length) % features.length);
  };

  // ✅ Siempre devuelve 3 cards, ciclando los índices con módulo
  const getVisibleCards = () => {
    const cards = [];
    for (let i = 0; i < 3; i++) {
      const index = (currentSlide + i) % features.length;
      cards.push({ ...features[index], originalIndex: index });
    }
    return cards;
  };

  const faqs = [
    {
      question:
        "¿Qué son los Kioskos de Autoservicio de Invu POS y cómo benefician a mi negocio?",
      answer:
        "Son pantallas donde tus clientes pueden realizar sus pedidos sin depender del personal. Mejoran la velocidad de atención, reducen filas y aumentan el ticket promedio gracias a sugerencias automáticas y combos inteligentes. ",
    },
    {
      question: "¿Los kioskos están integrados con mi sistema Invu POS?",
      answer:
        "Sí. Cada pedido pasa directamente al POS y se envía a cocina o barra en tiempo real. No hay digitación manual ni riesgos de equivocaciones, y todo se refleja en tu inventario y reportes al instante.",
    },
    {
      question: "¿Qué tipo de negocios pueden usar kioskos de autoservicio?",
      answer:
        "Funcionan perfecto para restaurantes de comida rápida, cafeterías, food courts, heladerías, panaderías y tiendas con alto flujo de clientes. Incluso puedes usar varios kioskos para manejar horas pico sin aumentar personal.",
    },
    {
      question: "¿Qué hardware necesito para instalar un kiosko?",
      answer:
        "En Invu POS contamos con los equipos necesarios que se adaptan a tu negocio: desde kioskos grandes para alto flujo hasta kioskos de mesa ideales para espacios reducidos. Solo necesitas conexión a internet y estás listo para comenzar. ",
    },
    {
      question: "¿Puedo personalizar la interfaz del kiosko?",
      answer:
        "Sí. Puedes ajustar tu menú, fotos, colores, promociones, idiomas y flujo de pedido. También puedes activar sugerencias automáticas (upselling) para aumentar las ventas por cliente. ",
    },
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

    // const extendedFeatures = [...features, ...features, ...features]; 

    const extendedFeaturesList = t("featuresecommercenew", { returnObjects: true });
  
    const isMobile =
    typeof window !== "undefined" && window.innerWidth < 768;

    const location = useLocation();
    const prefix = useLocalePrefix();
  
  const cardsPerSlide = isMobile ? 1 : 3;
  return (
    <>
       {isOpen && <Modal_started setIsOpen={setIsOpen} />}
       <Helmet>
        <title>POS para negocios en El Salvador | INVU POS</title>

        <meta
            name="description"
            content="Sistema POS para comercios, restaurantes, hoteles y negocios en El Salvador. Gestiona ventas, inventario, facturación y clientes con INVU POS."
        />

        <link rel="canonical" href="https://invupos.com/elsalvador" />

        <link rel="alternate" hrefLang="es-PA" href="https://invupos.com/" />
        <link rel="alternate" hrefLang="es-CO" href="https://invupos.com/colombia" />
        <link rel="alternate" hrefLang="es-CR" href="https://invupos.com/costarica" />
        <link rel="alternate" hrefLang="es-SV" href="https://invupos.com/elsalvador" />
        <link rel="alternate" hrefLang="es-GT" href="https://invupos.com/guatemala" />
        <link rel="alternate" hrefLang="es-MX" href="https://invupos.com/mexico" />
        <link rel="alternate" hrefLang="es-PE" href="https://invupos.com/peru" />
        <link rel="alternate" hrefLang="es-DO" href="https://invupos.com/republicadominicana" />
        <link rel="alternate" hrefLang="es-VE" href="https://invupos.com/venezuela" />
        <link rel="alternate" hrefLang="en-TT" href="https://invupos.com/trinidadytobago" />
        <link rel="alternate" hrefLang="en-US" href="https://invupos.com/unitedstates" />

        <link rel="alternate" hrefLang="x-default" href="https://invupos.com/" />
        </Helmet>
      <section className="w-full py-12 sm:py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {/* Card container mimicking the rounded canvas */}
          <div className="rounded-[28px] border border-neutral-200 bg-gray-50 shadow-sm ring-1 ring-black/5 flex flex-col ">
            {/* Top area */}
            <div className="mx-auto max-w-5xl px-6 text-center pt-14 pb-8 sm:pt-20">
              <h1 className="text-5xl font-extrabold leading-tight tracking-tight text-neutral-900 sm:text-5xl md:text-7xl">
               {t("homeheronewtitle")}
                <br className="hidden sm:block" />
                <span className="bg-gradient-clip12 text-[44px] sm:text-[64px] md:text-[76px] leading-none block mt-2">
                  INVU POS
                </span>
              </h1>

              {/* CTAs */}
              <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
                {/* <button
                onClick={() => {
                  setIsOpen(true);
                }}
                  className="inline-flex items-center justify-center rounded-full bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold px-6 py-3 text-base font-semibold text-white shadow-xl hover:bg-blue-700 hover:shadow-2xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600/60 transition-all duration-300"
                >
                 {t("homeheronewbutton1")}
                </button> */}

                <button
                    onClick={() => {
                      setIsOpen(true);
                    }}
                   className="inline-flex items-center justify-center rounded-full bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold px-6 py-3 text-base font-semibold text-white shadow-xl hover:bg-blue-700 hover:shadow-2xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600/60 transition-all duration-300"
                >
                  {t("homeheronewbutton2")}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="ml-1 h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </button>
              </div>

              {/* Trust row */}
              <div className="mt-6 lg:mt-12 mb-6 flex flex-col items-center text-center">
                <span className="text-xs font-semibold text-gray-500 uppercase tracking-widest">
                  {t("homeheronewavailable")}
                </span>

                <div className="mt-4 flex gap-x-8 justify-center">
                  <a href="https://bit.ly/4cXCHQm" target="_blank">
                    <svg
                      className="icon text-gray-500 hover:text-gray-800 transition duration-300 cursor-pointer"
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="m3.001 5.479l7.377-1.016v7.127H3zm0 13.042l7.377 1.017v-7.04H3zm8.188 1.125L21.001 21v-8.502h-9.812zm0-15.292v7.236h9.812V3z"
                      />
                    </svg>
                  </a>

                  <a href="https://bit.ly/3W8xWN4" target="_blank">
                    <svg
                      className="icon text-gray-500 hover:text-gray-800 transition duration-300 cursor-pointer"
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 256 315"
                    >
                      <path
                        fill="currentColor"
                        d="M213.803 167.03c.442 47.58 41.74 63.413 42.197 63.615c-.35 1.116-6.599 22.563-21.757 44.716c-13.104 19.153-26.705 38.235-48.13 38.63c-21.05.388-27.82-12.483-51.888-12.483c-24.061 0-31.582 12.088-51.51 12.871c-20.68.783-36.428-20.71-49.64-39.793c-27-39.033-47.633-110.3-19.928-158.406c13.763-23.89 38.36-39.017 65.056-39.405c20.307-.387 39.475 13.662 51.889 13.662c12.406 0 35.699-16.895 60.186-14.414c10.25.427 39.026 4.14 57.503 31.186c-1.49.923-34.335 20.044-33.978 59.822M174.24 50.199c10.98-13.29 18.369-31.79 16.353-50.199c-15.826.636-34.962 10.546-46.314 23.828c-10.173 11.763-19.082 30.589-16.678 48.633c17.64 1.365 35.66-8.964 46.64-22.262"
                      />
                    </svg>
                  </a>

                  <a href="https://bit.ly/4cJt3Be" target="_blank">
                    <svg
                      className="icon text-gray-500 hover:text-gray-800 transition duration-300 cursor-pointer"
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M12.735 1.828L13.6.254a.172.172 0 0 0-.3-.164l-.874 1.59a5.987 5.987 0 0 0-2.428-.508c-.869 0-1.69.181-2.424.506L6.698.09a.171.171 0 0 0-.232-.069a.169.169 0 0 0-.069.232l.866 1.572c-1.7.874-2.85 2.537-2.849 4.447l11.166-.001c0-1.91-1.146-3.57-2.845-4.444m-5.278 2.43a.467.467 0 1 1 .001-.934a.467.467 0 0 1 0 .935M15.542 6.7l.002 8.012c0 .481-.262.897-.648 1.127a1.31 1.31 0 0 1-.675.19l-.904.001v2.734a1.237 1.237 0 0 1-1.489 1.21a1.238 1.238 0 0 1-.99-1.209V16.03H9.163v2.735A1.237 1.237 0 0 1 7.925 20a1.239 1.239 0 0 1-1.238-1.235V16.03h-.901c-.521 0-.967-.3-1.182-.736a1.298 1.298 0 0 1-.141-.581l-.002-8.01zM2.74 6.47c.684 0 1.24.553 1.24 1.234v5.17a1.238 1.238 0 0 1-1.922 1.03a1.231 1.231 0 0 1-.557-1.03L1.5 7.703c0-.68.555-1.234 1.24-1.234m14.52-.001c.684 0 1.24.552 1.24 1.234v5.169c0 .683-.555 1.235-1.239 1.235c-.685 0-1.24-.552-1.24-1.235V7.702c0-.682.554-1.235 1.238-1.234M12.54 3.325a.467.467 0 1 1 0 .933a.467.467 0 1 1 0-.933"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>

            {/* Device mockup with screenshot (pegada abajo) */}
            <div className="mt-auto">
              <div className="relative mx-auto max-w-5xl w-full">
                <div className="rounded-b-[24px] bg-white overflow-hidden">
                  <img
                    src="https://img.invupos.com/webinvu/POS%20new/invupos4.png"
                    alt="INVU POS UI"
                    className="block h-auto w-full"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="px-6 mt-10 mb-20">
      <div className="max-w-6xl mx-auto">
        <div className="bg-[#F3F3F3] rounded-3xl p-6 md:p-16 relative overflow-visible">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            
            {/* === Imagen con desborde real === */}
            <div className="relative md:absolute md:left-0 md:top-1/2 md:-translate-y-1/2 md:-translate-x-12 lg:-translate-x-20 xl:-translate-x-10">
              <img
                src="https://img.invupos.com/webinvu/POS%20new/new%20cover%20invu%20pos%204.png"
                alt="Match perfecto para tu negocio"
                className=" lg:w-[580px] xl:w-[620px] h-auto object-contain drop-shadow-2xl"
              />
            </div>

            {/* === Contenido (con margen para evitar overlap en mobile) === */}
            <div className="md:col-start-2 flex flex-col gap-6 text-left">
              <h2 className="text-3xl md:text-3xl lg:text-5xl font-extrabold leading-tight text-gray-900">
                {t("homesection2title1")} <span className="text-blue-600">Match</span>
                <br />
                {t("homesection2title2")}
              </h2>

              <p className="text-gray-700 text-base md:text-lg leading-relaxed">
                {t("homesection2description")}
              </p>


              <div className="grid grid-cols-2 gap-4 w-full max-w-lg">
                    <div
                      className="bg-gray-100 border border-gray-200 rounded-full px-6 py-2 text-lg font-semibold flex items-center justify-between shadow-sm"
                    >
                      <span>{t("homesection2item1")}</span>
                      <span className="text-green-500 text-2xl">✔</span>
                    </div>
                    <div
                      className="bg-gray-100 border border-gray-200 rounded-full px-6 py-2 text-lg font-semibold flex items-center justify-between shadow-sm"
                    >
                      <span>{t("homesection2item2")}</span>
                      <span className="text-green-500 text-2xl">✔</span>
                    </div>
                    <div
                      className="bg-gray-100 border border-gray-200 rounded-full px-6 py-2 text-lg font-semibold flex items-center justify-between shadow-sm"
                    >
                      <span>{t("homesection2item3")}</span>
                      <span className="text-green-500 text-2xl">✔</span>
                    </div>
                    <div
                      className="bg-gray-100 border border-gray-200 rounded-full px-6 py-2 text-lg font-semibold flex items-center justify-between shadow-sm"
                    >
                      <span>{t("homesection2item4")}</span>
                      <span className="text-green-500 text-2xl">✔</span>
                    </div>
                    <div
                      className="bg-gray-100 border border-gray-200 rounded-full px-6 py-2 text-lg font-semibold flex items-center justify-between shadow-sm"
                    >
                      <span>{t("homesection2item5")}</span>
                      <span className="text-green-500 text-2xl">✔</span>
                    </div>
              </div>

          {/* CTA Button */}
          <div className="mt-2 mb-3">
                <Link
                  to={`${prefix}` + "/productos/punto-de-venta"}
                  onClick={() => window.scrollTo(0, 0)}
                className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold px-2 py-3.5 rounded-full text-base md:text-lg font-semibold shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200">
                  {t("homesection2button")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

      <Support />

      <div className="-mt-24">
      <Industries_carousel_global />
      </div>

      <div className="min-h-screen bg-gray-100 py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Left Card - Aliados */}
            <div className="bg-white rounded-3xl p-4 shadow-lg relative overflow-hidden">
              {/* Header */}

              <h2 className="text-4xl lg:text-5xl font-bold text-black mb-8">
                <span className="text-blue-600">{t("kioskcta1span")}</span> {t("kioskcta1title")}
              </h2>

              {/* Description */}
              <p className="text-gray-700 text-lg leading-relaxed mb-12">
             {t("kioskcta1description")}
              </p>

              {/* Imagen CLAU.IO */}
              <div className="relative bg-gray-50 rounded-2xl overflow-hidden h-80 mb-8 flex items-center justify-center">
                <img
                  src="https://img.invupos.com/webinvu/Kiosk_new/img3.png"
                  alt="Plataforma CLAU.IO"
                  className="w-full h-full object-contain"
                />
              </div>

              {/* CTA Button */}
              <Link
              to={`${prefix}` + "/productos/quioscos"}
              onClick={() => window.scrollTo(0, 0)}
              className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-lg px-2 py-3.5 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105">
               {t("kioskcta1button")}
              </Link>
            </div>

            {/* Right Card - Loyalty */}
            <div className="bg-white rounded-3xl p-12 shadow-lg relative overflow-hidden flex flex-col">
              {/* Header */}
              <div className="text-center mb-8">
                <h2 className="text-4xl lg:text-5xl font-bold mb-6">
                  <span className="text-black">{t("kioskcta2title")} </span>
                  <span className="text-blue-600">{t("kioskcta2span")}</span>
                </h2>

                {/* Description */}
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  {t("kioskcta2description")}
                </p>

                {/* CTA Button */}
                <Link
                to={`${prefix}` + "/productos/programa-de-lealtad"}
                onClick={() => window.scrollTo(0, 0)}
                className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-lg px-4 py-3.5 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105">
                  {t("kioskcta2button")}
                </Link>
              </div>

              {/* Imagen de celulares */}
              <div className="relative flex-1 flex items-end justify-center mt-8">
                <div className="w-full h-96 bg-gray-50 rounded-2xl overflow-hidden flex items-center justify-center">
                  <img
                    src="https://img.invupos.com/webinvu/Kiosk_new/img4.png"
                    alt="Apps móviles Loyalty"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="px-6 py-12 md:py-20">
  <div className="max-w-7xl mx-auto bg-white rounded-3xl">
    {/* --- BLOQUE DE TEXTO (visible solo en mobile, antes de la imagen) --- */}
    <div className="w-full md:hidden pb-8">
      <div className="text-center max-w-md mx-auto">
        <h2 className="text-3xl font-extrabold text-black leading-tight">
          {t("homesectionctatitle1")} <span className="text-[#0056FB]">+100</span>{" "}
          {t("homesectionctatitle2")}
        </h2>

        <div className="mt-5">
          <button
            onClick={() => {
              setIsOpen(true);
            }}
            className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-base px-8 py-3 rounded-full transition transform hover:scale-105 shadow-md"
          >
            {t("homesectionctabutton")}
          </button>
        </div>
      </div>
    </div>

    {/* --- CONTENEDOR DE IMAGEN CON TEXTO SOBREPUESTO (desktop) --- */}
    <div className="w-full relative">
      {/* Imagen */}
      <img
        src="https://img.invupos.com/webinvu/Clients%20mx/cover-integrations-global%20%281%29.png"
        alt="Integraciones"
        className="w-full h-auto block !shadow-none rounded-3xl"
        style={{ boxShadow: "none", filter: "none" }}
      />

      {/* --- BLOQUE DE TEXTO (visible solo en desktop, sobrepuesto) --- */}
      <div className="hidden md:block absolute top-12 right-12 lg:top-16 lg:right-16">
        <div className="text-right max-w-3xl">
          <h2 className="text-4xl lg:text-6xl font-extrabold text-black leading-tight">
          {t("homesectionctatitle1")} <span className="text-[#0056FB]">+100</span>{" "}
          {t("homesectionctatitle2")}
          </h2>

          <div className="mt-10">
          <Link
              to={`${prefix}` + "/mas-herramientas/integraciones"}
              onClick={() => window.scrollTo(0, 0)}
              className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-lg md:px-10 md:py-4 rounded-full transition transform hover:scale-105 shadow-md"
              aria-label="Conoce las integraciones"
            >
             {t("homesectionctabutton")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 p-8">
  <div className="max-w-7xl mx-auto">
    {/* Header */}
    <div className="flex flex-col lg:flex-row justify-between items-center gap-6 mb-12 text-center lg:text-left">
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 max-w-2xl leading-tight">
        {t("reasons_title")}
      </h1>

      <button
        onClick={() => {
          setIsOpen(true);
        }}
        className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-base sm:text-lg px-10 sm:px-16 py-3 sm:py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
      >
        {t("reasons_cta")}
      </button>
    </div>

    {/* Carousel */}
    <div className="relative overflow-hidden">
      <div
        className="flex transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]"
        style={{
          transform: `translateX(-${currentSlide * (100 / cardsPerSlide)}%)`,
        }}
      >
        {extendedFeaturesList.map((feature, idx) => (
          <div
            key={idx}
            className="w-full md:w-1/3 flex-shrink-0 px-3 md:px-4 animate-fadeup"
            style={{ animationDelay: `${(idx % 3) * 0.1}s` }}
          >
            {/* Card */}
            <div className="group relative bg-white rounded-3xl p-8 shadow-sm hover:shadow-2xl hover:-translate-y-2 hover:scale-[1.02] transition-all duration-700 ease-in-out overflow-hidden h-full flex flex-col">
              {/* Brillo diagonal */}
              <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none"></div>

              {/* Borde brillante */}
              <div className="absolute inset-0 rounded-3xl border border-transparent group-hover:border-blue-100 transition-all duration-700"></div>

              {/* Tag */}
              <div className="flex items-center justify-between mb-6">
                <span className="text-blue-600 font-semibold text-sm">
                  {feature.tag}
                </span>
                <div className="bg-blue-600 rounded-full p-1.5 flex items-center justify-center">
                  <svg
                    className="w-4 h-4 text-white"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M13 4L6 11L3 8"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 mb-6 leading-relaxed flex-grow">
                {feature.description}
              </p>

              {/* Image */}
              <div className="relative bg-white rounded-2xl overflow-hidden flex items-center justify-center h-64 mb-6">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="object-contain max-h-full max-w-full transition-transform duration-700 ease-in-out group-hover:scale-110"
                />
              </div>

              {/* Plus Button */}
              <div>
                <button className="mt-auto bg-blue-50 hover:bg-blue-100 rounded-full p-3 transition-transform duration-500 hover:scale-110 shadow-sm">
                  <svg
                    className="w-5 h-5 text-blue-600"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M10 4V16M4 10H16"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Botones */}
      <div className="flex justify-center gap-4 mt-6">
        <button
          onClick={prevSlide}
          className="bg-white hover:bg-gray-100 rounded-full p-4 shadow-md transition-transform hover:scale-110"
          aria-label="Anterior"
        >
          <svg className="w-6 h-6 text-gray-700" viewBox="0 0 24 24" fill="none">
            <path
              d="M15 18L9 12L15 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <button
          onClick={nextSlide}
          className="bg-white hover:bg-gray-100 rounded-full p-4 shadow-md transition-transform hover:scale-110"
          aria-label="Siguiente"
        >
          <svg className="w-6 h-6 text-gray-700" viewBox="0 0 24 24" fill="none">
            <path
              d="M9 18L15 12L9 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      {/* Indicadores */}
      <div className="flex justify-center gap-2 mt-6">
        {features.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrentSlide(idx)}
            className={`h-2 rounded-full transition-all ${
              idx === currentSlide
                ? "w-8 bg-blue-600"
                : "w-2 bg-gray-300 hover:bg-gray-400"
            }`}
            aria-label={`Ir a slide ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  </div>
</div>



      <div className="px-6 mt-16">
        <div className="max-w-7xl mx-auto bg-[#F3F3F3] rounded-3xl shadow-xl p-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Imagen reducida (igual estilo que el CTA anterior) */}
            <div className="order-2 lg:order-1 flex justify-center">
              <img
                className=" lg:w-[550px] drop-shadow-xl"
                src="https://img.invupos.com/webinvu/homenew/Group%201171275526.png"
                alt="POS"
              />
            </div>

            {/* Contenido */}
            <div className="order-1 lg:order-2 space-y-6">
              <h2 className="text-4xl md:text-5xl font-extrabold leading-tight text-gray-900">
                {t("homesectioncta2title1")}
              </h2>

              <p className="text-lg md:text-2xl text-gray-700 leading-relaxed">
                {t("homesectioncta2description")}
              </p>

              <button  
                onClick={() => {
                  setIsOpen(true);
                }}
              className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-lg px-10 py-4 rounded-full shadow-md hover:scale-105 transition">
                {t("homesectioncta2button")}
              </button>
            </div>
          </div>
        </div>
      </div>

    <section class="bg-white">
        <div class="max-w-7xl px-6 py-6 mx-auto">
          <main class="relative z-20 w-full mt-8 md:flex md:items-center xl:mt-12">
          <div class="absolute w-full bg-[#0056FB] -z-10 md:h-[450px] rounded-3xl"></div>
          <div class="w-full p-6 bg-[#0056FB] md:flex md:items-center rounded-2xl md:bg-transparent md:p-0 lg:px-12 md:justify-evenly">
              <div class="mt-2 md:mx-6">
              <h1 className="text-4xl font-extrabold text-white md:text-5xl lg:text-6xl leading-tight">
                {t("homesectioncta3title1")}
              </h1>
              
              <div className="mt-6 space-y-6">
                <p className="font-light text-xl md:text-2xl tracking-normal leading-relaxed text-white/90">
                  {t("homesectioncta3description")}
                </p>
                
                <Link
                to={`${prefix}` + "/detalles-de-equipos"} onClick={() => window.scrollTo(0, 0)}
                className="inline-block rounded-lg bg-white px-10 py-4 text-base md:text-lg font-semibold text-blue-700 hover:scale-105 transition-transform shadow-lg uppercase tracking-wide">
                  {t("homesectioncta3button")}
                </Link>
                </div>
              </div>
              <img
            className="object-contain md:h-[600px] md:object-cover"
                src="https://img.invupos.com/webinvu/POS%20new/cover-new-imin.png"
                alt="client photo"
              />
            </div>
          </main>
        </div>
      </section>

      <Contact_form />
    </>
  );
};

export default Home_new_sv;